import { UI_SUPPORTED_ARCHITECTURES } from "./constants";

export const fieldToArchitectureTypeMap = {
    "srpdName": UI_SUPPORTED_ARCHITECTURES,
    "srpdVersion": UI_SUPPORTED_ARCHITECTURES,
    "srpAssignee": UI_SUPPORTED_ARCHITECTURES,
    "srpWatchers": UI_SUPPORTED_ARCHITECTURES,
    "srpSchemaVersion": UI_SUPPORTED_ARCHITECTURES,
    "releaseObjectKey": UI_SUPPORTED_ARCHITECTURES,
    "fixVersion": UI_SUPPORTED_ARCHITECTURES,
    "moduleInformation": {
        "moduleName": UI_SUPPORTED_ARCHITECTURES,
        "vehiclePrograms": UI_SUPPORTED_ARCHITECTURES,
        "lveas": UI_SUPPORTED_ARCHITECTURES,
        "gpdsMilestone": UI_SUPPORTED_ARCHITECTURES,
        "publicRoadWorthy": UI_SUPPORTED_ARCHITECTURES,
        "criticalAttributesImpacted": UI_SUPPORTED_ARCHITECTURES,
        "cmaEnabled": UI_SUPPORTED_ARCHITECTURES,
    },
    "machineList": [
        {
            "machineName": UI_SUPPORTED_ARCHITECTURES,
            "machineType": UI_SUPPORTED_ARCHITECTURES,
            "canDiagRxId": UI_SUPPORTED_ARCHITECTURES,
            "canDiagTxId": UI_SUPPORTED_ARCHITECTURES,
            "variantList": [
                {
                    "variantName": UI_SUPPORTED_ARCHITECTURES,
                    "logicalDiagAddress": ["FNV4", "EVO"],
                    "ucmSubordinateId": ["FNV4"],
                    "flashingAdapterAddress": ["FNV4"],
                    "arxmlRequired": ["FNV4"],
                    "vspRequired": ["FNV4"],
                    "otaCapable": UI_SUPPORTED_ARCHITECTURES,
                    "flashCapability": UI_SUPPORTED_ARCHITECTURES,
                    "commsProtocol": UI_SUPPORTED_ARCHITECTURES,
                    "publicTopology": UI_SUPPORTED_ARCHITECTURES,
                    "privateTopology": UI_SUPPORTED_ARCHITECTURES,
                    "ethernetTopology": UI_SUPPORTED_ARCHITECTURES,
                    "asilRating": UI_SUPPORTED_ARCHITECTURES,
                    // nonSchema fields start
                    "supplier": UI_SUPPORTED_ARCHITECTURES,
                    // nonSchema fields end

                    "clusterList": [

                        {
                            "clusterName": UI_SUPPORTED_ARCHITECTURES,
                            "clusterVersion": UI_SUPPORTED_ARCHITECTURES,
                            "changeLevel": UI_SUPPORTED_ARCHITECTURES,
                            "clusterUrl": UI_SUPPORTED_ARCHITECTURES,
                            "clusterType": UI_SUPPORTED_ARCHITECTURES,
                            "configurationType": ["FNV4"],
                            "ecuExtractVersion": ["FNV4", "EVO"],
                            "f163D2SpecVersion": UI_SUPPORTED_ARCHITECTURES,
                            "part2SpecUrl": UI_SUPPORTED_ARCHITECTURES,
                            "wersConcernNum": UI_SUPPORTED_ARCHITECTURES,
                            "f113ECUAssemblyNum": UI_SUPPORTED_ARCHITECTURES,
                            "f111CoreAssemblyNum": UI_SUPPORTED_ARCHITECTURES,
                            "swPartNumber": UI_SUPPORTED_ARCHITECTURES,
                            "selectionCriteriaList": [
                                {
                                    "modelYear": UI_SUPPORTED_ARCHITECTURES,
                                    "programCode": UI_SUPPORTED_ARCHITECTURES,
                                    "ncPartNumber": UI_SUPPORTED_ARCHITECTURES,
                                    "mfalCode": UI_SUPPORTED_ARCHITECTURES,
                                    "did": UI_SUPPORTED_ARCHITECTURES,
                                }
                            ],
                            "actionType": UI_SUPPORTED_ARCHITECTURES,
                            "updateType": ["FNV4"],
                            "udsMethod": ["FNV4", "EVO"],
                            "inhibitRequired": UI_SUPPORTED_ARCHITECTURES,
                            "sessionSequence": ["FNV4"],
                            "swInstallationSequence": UI_SUPPORTED_ARCHITECTURES,
                            "swDownloadMethod": UI_SUPPORTED_ARCHITECTURES,
                            "updateTimeInSeconds": UI_SUPPORTED_ARCHITECTURES,
                            "assemblyCritical": UI_SUPPORTED_ARCHITECTURES,
                            "productionReleaseIntent": UI_SUPPORTED_ARCHITECTURES,
                            "resetDelay": ["FNV4"],
                            "swSignRequest": UI_SUPPORTED_ARCHITECTURES,
                            "swSigningId": UI_SUPPORTED_ARCHITECTURES,
                            "ucmPackagePath": ["FNV4"],
                            "programmingMethod": UI_SUPPORTED_ARCHITECTURES,

                            // non-schema fields start
                            "vbfType": UI_SUPPORTED_ARCHITECTURES,
                            // VADR & IVS fields
                            "VADRnIVSInformation": {
                                "softwareCategory": UI_SUPPORTED_ARCHITECTURES,
                                "icepackLineage": UI_SUPPORTED_ARCHITECTURES,
                                "dependencyName": UI_SUPPORTED_ARCHITECTURES,
                                "dependencyVersion": UI_SUPPORTED_ARCHITECTURES,
                                "relationshipType": UI_SUPPORTED_ARCHITECTURES,
                                "relatedIcepack": UI_SUPPORTED_ARCHITECTURES,
                            }

                        }
                    ]
                }
            ]
        }
    ],
    "preassemblyImage": {
            "preassemblyImageName": UI_SUPPORTED_ARCHITECTURES,
            "preassemblyImageVersion": UI_SUPPORTED_ARCHITECTURES,
            "ucmPackagePath": UI_SUPPORTED_ARCHITECTURES,
            "preassemblyImageUrl": UI_SUPPORTED_ARCHITECTURES,
            "f111coreAssemblyNum": UI_SUPPORTED_ARCHITECTURES,
            "clusterList": [
                {
                    "clusterName": UI_SUPPORTED_ARCHITECTURES,
                    "clusterVersion": UI_SUPPORTED_ARCHITECTURES,
                }
            ],
        }
}

export const fieldsPrefilledByCatalogList = [
    // General
    "srpdName",

    // moduleInformation
    "moduleInformation.vehiclePrograms",
    "moduleInformation.moduleName",
    "moduleInformation.lveas",

    // machineList
    "machineList.0.machineName",
    "machineList.0.machineType",
    "machineList.0.canDiagRxId",
    "machineList.0.canDiagTxId",

    // variantList
    "machineList.0.variantList.0.variantName",
    "machineList.0.variantList.0.ucmSubordinateId",
    "machineList.0.variantList.0.flashingAdapterAddress",
    "machineList.0.variantList.0.logicalDiagAddress",
    "machineList.0.variantList.0.arxmlRequired",
    "machineList.0.variantList.0.otaCapable",
    "machineList.0.variantList.0.asilRating",
    "machineList.0.variantList.0.flashCapability",
    "machineList.0.variantList.0.commsProtocol",
    "machineList.0.variantList.0.publicTopology",
    "machineList.0.variantList.0.privateTopology",
    "machineList.0.variantList.0.ethernetTopology",

    // clusterList
    "machineList.0.variantList.0.clusterList.0.clusterName",
    "machineList.0.variantList.0.clusterList.0.clusterType",
    "machineList.0.variantList.0.clusterList.0.configurationType",
    "machineList.0.variantList.0.clusterList.0.swInstallationSequence",
    "machineList.0.variantList.0.clusterList.0.swDownloadMethod",
    // Temporarily disable to test validation
    // "machineList.0.variantList.0.clusterList.0.updateType",
    "machineList.0.variantList.0.clusterList.0.sessionSequence",
    "machineList.0.variantList.0.clusterList.0.inhibitRequired",
    "machineList.0.variantList.0.clusterList.0.udsMethod",
    "machineList.0.variantList.0.clusterList.0.f111CoreAssemblyNum",      
    
    // selectionCriteriaList
    "machineList.0.variantList.0.clusterList.0.selectionCriteriaList.0.programCode",
    "machineList.0.variantList.0.clusterList.0.selectionCriteriaList.0.modelYear",
    
];

export const fieldsPrefilledByCatalogMap = {
    "FNV2/FNV3/FNV3.2/FNV3.4": 
        [
            // General
            "srpdName",

            // moduleInformation
            "moduleInformation.vehiclePrograms",
            "moduleInformation.moduleName",
            "moduleInformation.lveas",

            // machineList
            "machineList.0.machineName",
            "machineList.0.machineType",
            "machineList.0.canDiagRxId",
            "machineList.0.canDiagTxId",

            // variantList
            "machineList.0.variantList.0.variantName",
            "machineList.0.variantList.0.ucmSubordinateId",
            "machineList.0.variantList.0.flashingAdapterAddress",
            "machineList.0.variantList.0.logicalDiagAddress",
            "machineList.0.variantList.0.arxmlRequired",
            "machineList.0.variantList.0.otaCapable",
            "machineList.0.variantList.0.asilRating",
            "machineList.0.variantList.0.flashCapability",
            "machineList.0.variantList.0.commsProtocol",
            "machineList.0.variantList.0.publicTopology",
            "machineList.0.variantList.0.privateTopology",
            "machineList.0.variantList.0.ethernetTopology",

            // clusterList
            "machineList.0.variantList.0.clusterList.0.clusterName",
            "machineList.0.variantList.0.clusterList.0.clusterType",
            "machineList.0.variantList.0.clusterList.0.configurationType",
            "machineList.0.variantList.0.clusterList.0.swInstallationSequence",
            "machineList.0.variantList.0.clusterList.0.swDownloadMethod",
            // Temporarily disable to test validation
            // "machineList.0.variantList.0.clusterList.0.updateType",
            "machineList.0.variantList.0.clusterList.0.sessionSequence",
            "machineList.0.variantList.0.clusterList.0.inhibitRequired",
            "machineList.0.variantList.0.clusterList.0.udsMethod",
            "machineList.0.variantList.0.clusterList.0.f111CoreAssemblyNum",      
            
            // selectionCriteriaList
            "machineList.0.variantList.0.clusterList.0.selectionCriteriaList.0.programCode",
            "machineList.0.variantList.0.clusterList.0.selectionCriteriaList.0.modelYear",
            
        ],
    "FNV4":
        [
            // General
        
            // moduleInformation
            "moduleInformation.vehiclePrograms",
            "moduleInformation.moduleName",
            "moduleInformation.lveas",
        
            // machineList
            "machineList.0.machineName",
            "machineList.0.machineType",
            "machineList.0.canDiagRxId",
            "machineList.0.canDiagTxId",
        
            // variantList
            "machineList.0.variantList.0.variantName",
            "machineList.0.variantList.0.ucmSubordinateId",
            "machineList.0.variantList.0.flashingAdapterAddress",
            "machineList.0.variantList.0.logicalDiagAddress",
            "machineList.0.variantList.0.arxmlRequired",
            "machineList.0.variantList.0.otaCapable",
            "machineList.0.variantList.0.asilRating",
            "machineList.0.variantList.0.flashCapability",
            "machineList.0.variantList.0.commsProtocol",
            "machineList.0.variantList.0.publicTopology",
            "machineList.0.variantList.0.privateTopology",
            "machineList.0.variantList.0.ethernetTopology",
        
            // clusterList
            // No supported fields since no data in catalog for fnv4
            // selectionCriteriaList
            "machineList.0.variantList.0.clusterList.0.selectionCriteriaList.0.programCode",
            "machineList.0.variantList.0.clusterList.0.selectionCriteriaList.0.modelYear",
        ]
};

export const requiredPerArchitectureMap = {
    "srpdName": UI_SUPPORTED_ARCHITECTURES,
    "srpdVersion": UI_SUPPORTED_ARCHITECTURES,
    "srpAssignee": UI_SUPPORTED_ARCHITECTURES,
    "srpWatchers": [],
    "srpSchemaVersion": [],
    "electricalArchitecture": [],
    "releaseObjectKey": UI_SUPPORTED_ARCHITECTURES,
    "fixVersion": UI_SUPPORTED_ARCHITECTURES,
    "moduleInformation": {
        "moduleName": UI_SUPPORTED_ARCHITECTURES,
        "vehiclePrograms": UI_SUPPORTED_ARCHITECTURES,
        "lveas": UI_SUPPORTED_ARCHITECTURES,
        "gpdsMilestone": UI_SUPPORTED_ARCHITECTURES,
        "publicRoadWorthy": UI_SUPPORTED_ARCHITECTURES,
        "criticalAttributesImpacted": UI_SUPPORTED_ARCHITECTURES,
        "cmaEnabled": UI_SUPPORTED_ARCHITECTURES,
    },
    "machineList": [
        {
            "machineName": UI_SUPPORTED_ARCHITECTURES,
            "machineType": UI_SUPPORTED_ARCHITECTURES,
            "canDiagRxId": UI_SUPPORTED_ARCHITECTURES,
            "canDiagTxId": [],
            "variantList": [
                {
                    "variantName": UI_SUPPORTED_ARCHITECTURES,
                    "logicalDiagAddress": ["FNV4", "EVO"],
                    "ucmSubordinateId": ["FNV4"],
                    "flashingAdapterAddress": ["FNV4"],
                    "arxmlRequired": ["FNV4"],
                    "vspRequired": ["FNV4"],
                    "otaCapable": [],
                    "flashCapability": [],
                    "commsProtocol": [],
                    "publicTopology": [],
                    "privateTopology": [],
                    "ethernetTopology": [],
                    "asilRating": UI_SUPPORTED_ARCHITECTURES,
                    // nonSchema fields start
                    "supplier": UI_SUPPORTED_ARCHITECTURES,
                    // nonSchema fields end
                    "clusterList": [

                        {
                            "clusterName": UI_SUPPORTED_ARCHITECTURES,
                            "changeLevel": UI_SUPPORTED_ARCHITECTURES,
                            "clusterVersion": UI_SUPPORTED_ARCHITECTURES,
                            "clusterUrl": UI_SUPPORTED_ARCHITECTURES,
                            "clusterType": UI_SUPPORTED_ARCHITECTURES,
                            "configurationType": [],
                            "ecuExtractVersion": [],
                            "f163D2SpecVersion": [],
                            "part2SpecUrl": UI_SUPPORTED_ARCHITECTURES,
                            "wersConcernNum": [],
                            "f113ECUAssemblyNum": UI_SUPPORTED_ARCHITECTURES,
                            "f111CoreAssemblyNum": UI_SUPPORTED_ARCHITECTURES,
                            "swPartNumber": UI_SUPPORTED_ARCHITECTURES,
                            "selectionCriteriaList": [
                                {
                                    "modelYear": UI_SUPPORTED_ARCHITECTURES,
                                    "programCode": UI_SUPPORTED_ARCHITECTURES,
                                    "ncPartNumber": [],
                                    "mfalCode": [],
                                    "did": [],
                                }
                            ],
                            "actionType": UI_SUPPORTED_ARCHITECTURES,
                            "updateType": ["FNV4"],
                            "udsMethod": ["FNV4"],
                            "inhibitRequired": UI_SUPPORTED_ARCHITECTURES,
                            "sessionSequence": ["FNV4"],
                            "swInstallationSequence": UI_SUPPORTED_ARCHITECTURES,
                            "swDownloadMethod": UI_SUPPORTED_ARCHITECTURES,
                            "updateTimeInSeconds": UI_SUPPORTED_ARCHITECTURES,
                            "assemblyCritical": UI_SUPPORTED_ARCHITECTURES,
                            "productionReleaseIntent": UI_SUPPORTED_ARCHITECTURES,
                            "resetDelay": [],
                            "swSignRequest": UI_SUPPORTED_ARCHITECTURES,
                            "swSigningId": [],
                            "ucmPackagePath": [],
                            "programmingMethod": UI_SUPPORTED_ARCHITECTURES,

                            // VADR & IVS fields
                            "VADRnIVSInformation": {
                                "softwareCategory": [],
                                "icepackLineage": [],
                                "dependencyName": [],
                                "dependencyVersion": [],
                                "relationshipType": [],
                                "relatedIcepack": [],
                            }

                        }
                    ]
                }
            ]
        }
    ],

}

export const checkIfFieldMatchesArchitecture = (pathToField, architectureType) => {
    try {
        const architectures = deepFind(fieldToArchitectureTypeMap, pathToField);
        return architectures.includes(architectureType);
        
    } catch (e) {
        
        console.log(`Error in checkIfFieldMatchesArchitecture for field: ${pathToField}, architectureType: ${architectureType}`, e);
        return false;
    }
}

export const checkIfFieldIsRequiredPerArchitecture = (pathToField, architectureType) => {
    try {
        const requiredFields = deepFind(requiredPerArchitectureMap, pathToField);
        if (requiredFields) {
            return requiredFields.includes(architectureType);
        }
        return false;
    } catch (e) {
        console.log(`Error in checkIfFieldIsRequiredPerArchitecture for field: ${pathToField}, architectureType: ${architectureType}`, e);
        return false;
    }
}


// Simple deep find function found at https://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-and-arrays-by-string-path
export function deepFind(obj, path) {
    let paths = path.split('.')
      , current = obj
      , i;
  
    for (i = 0; i < paths.length; ++i) {
      if (current[paths[i]] === undefined) {
        return undefined;
      } else {
        current = current[paths[i]];
      }
    }
    return current;
  }


export const checkIfFieldIsPrefilledByCatalog = (pathToField, architectureType) => {
    const fieldsPrefilledByCatalog = UI_SUPPORTED_ARCHITECTURES.includes(architectureType) ? fieldsPrefilledByCatalogMap["FNV2/FNV3/FNV3.2/FNV3.4"] : [];
    return !!(fieldsPrefilledByCatalog?.includes(pathToField));
}